<template>
  <Modal
    buttons-class="justify-center"
    hide-close-button
    :modal-style="{ maxWidth: '400px' }"
    offset-menu
    persistent="persistent"
    @close="$emit('cancel')"
  >
    <div class="text-center">
      <i18n-t
        :keypath="messageLocalisationKey"
        scope="global"
      >
        <template #platformName> {{ appConfig.platformName }} </template>
        <template #organisationName>
          <strong>{{ organisationName }}</strong>
        </template>
        <template #cost>
          <span class="text-tv text-bold">
            {{ mediaItemCost }}
          </span>
        </template>
      </i18n-t>
    </div>
    <template #buttons>
      <BaseButton
        color="secondary"
        :label="$t('global.cancel')"
        new-design
        @click="cancel"
      />
      <BaseButton
        color="danger"
        :label="confirmButtonLabel"
        new-design
        @click="confirm"
      />
    </template>
  </Modal>
</template>

<script>
import { storeToRefs } from "pinia";

import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";
import { prettyNumber } from "shared/helpers/number";
import { useGlobalStore } from "shared/stores/global";
import { useUserStore } from "shared/stores/user";

export default {
  name: "RequestMediaTranscriptItemConfirmModal",
  components: {
    BaseButton,
    Modal,
  },
  props: {
    type: {
      type: String,
      required: true,
      default: "media_request",
    },
  },
  emits: ["cancel", "close", "confirm"],
  setup() {
    const userStore = useUserStore();
    const { organisation } = storeToRefs(userStore);

    const globalStore = useGlobalStore();
    const { appConfig } = storeToRefs(globalStore);

    return { organisation, appConfig };
  },
  computed: {
    organisationName() {
      return this.organisation.name;
    },
    hasCredit() {
      return this.$features.hasCredits(this.type);
    },
    messageLocalisationKey() {
      if (this.type === "media_request") {
        return "modals.request_media_transcript_item_confirm_modal.media_request_message";
      }

      if (!this.hasCredit) {
        return "modals.request_media_transcript_item_confirm_modal.transcript_request_no_credit_message";
      }

      return "modals.request_media_transcript_item_confirm_modal.transcript_request_message";
    },
    mediaItemCost() {
      return `${prettyNumber(
        this.$features.getCost(this.type),
        "currency"
      )} + ${this.$t("tax")}`;
    },
    confirmButtonLabel() {
      if (this.type === "media_request") {
        return this.$t(
          "modals.request_media_transcript_item_confirm_modal.media_request_confirm_button",
          {
            cost: this.mediaItemCost,
          }
        );
      }

      return this.$t(
        "modals.request_media_transcript_item_confirm_modal.transcript_request_confirm_button",
        {
          cost: this.mediaItemCost,
        }
      );
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.streem-modal2) {
  width: auto !important;
  margin: 0 auto !important;
}

:deep(.streem-modal2-buttons) {
  border-top: none !important;
  display: flex;
  padding: var(--s-spacing-lg);
  padding-top: 0;
  gap: var(--s-spacing-lg);
  justify-content: center;
}

:deep(.base-button) {
  white-space: nowrap;
}
</style>
